module.exports = __webpack_public_path__ + "assets/img/wps.5e4496d5.svg";